import axios from 'axios';

import IComposableDashboardCollectionDTO from '../types/IComposableDashboardCollection';

const url = 'wsreporting/api/dashboard-collection';

export const fetchDashboardCollections = () => axios.get(`${url}/fetch-dashboard-collections`);

export const saveDashboardCollection = (query: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/save-dashboard-collection`, query);

export const updateDashboardCollection = (query: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/update-dashboard-collection`, query);

export const renameDashboardCollection = (query: IComposableDashboardCollectionDTO) =>
  axios.put(`${url}/rename-dashboard-collection`, query);

export const deleteDashbaordCollection = (id: string) =>
  axios.delete(`${url}/delete-dashboard-collection`, { params: { id } });

export const fetchDashboardCollectionsAssignedToClients = (assignToClients: boolean) =>
  axios.get(`${url}/assigned-to-clients`, { params: { assignToClients } });

export const assignUnAssignToClients = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unAssign-to-clients`, request);

export const fetchDashboardCollectionsAssignedToClientSpoc = (assignToClientSpoc: boolean) =>
  axios.get(`${url}/assigned-to-client-spoc`, { params: { assignToClientSpoc } });

export const assignUnAssignToClientSpoc = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unAssign-to-client-spoc`, request);

export const fetchDashboardCollectionsAssignedToOrganisationalUnitAccountManagers = (
  assignToAccountManagerOU: boolean
) => axios.get(`${url}/assigned-to-ou-account-managers`, { params: { assignToAccountManagerOU } });

export const assignUnAssignToOrganisationalUnitAccountManagers = (
  request: IComposableDashboardCollectionDTO
) => axios.post(`${url}/assign-unassign-to-ou-account-managers`, request);

export const fetchDashboardCollectionsAssignedToOrganisationalUnitTeams = (
  assignToTeamsOU: boolean
) => axios.get(`${url}/assigned-to-ou-teams`, { params: { assignToTeamsOU } });

export const assignUnAssignToOrganisationalUnitTeams = (
  request: IComposableDashboardCollectionDTO
) => axios.post(`${url}/assign-unassign-to-ou-teams`, request);

export const fetchDashboardCollectionsAssignedToTeams = (assignToTeams: boolean) =>
  axios.get(`${url}/assigned-to-teams`, { params: { assignToTeams } });

export const assignUnAssignToTeams = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-teams`, request);

export const fetchDashboardCollectionsAssignedToAccountManagers = (
  assignToAccountManagers: boolean
) => axios.get(`${url}/assigned-to-account-managers`, { params: { assignToAccountManagers } });

export const assignUnAssignToAccountManagers = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-account-managers`, request);

export const fetchDashboardCollectionsAssignedToBusinessUnit = (assignToBusinessUnit: boolean) =>
  axios.get(`${url}/assigned-to-business-unit`, { params: { assignToBusinessUnit } });

export const assignUnAssignToBusinessUnit = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-business-unit`, request);

export const fetchDashboardCollectionsAssignedToRecruiters = () =>
  axios.get(`${url}/assigned-to-recruiters`);

export const fetchDashboardCollectionsAssignedToClientUnit = (assignToClientUnit: boolean) =>
  axios.get(`${url}/assigned-to-client-unit`, { params: { assignToClientUnit } });

export const assignUnAssignToClientUnit = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-client-unit`, request);

export const fetchDashboardCollectionsAssignedToClientContactUnit = (
  assignToClientContactUnit: boolean
) => axios.get(`${url}/assigned-to-client-contact-unit`, { params: { assignToClientContactUnit } });

export const assignUnAssignToClientContactUnit = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-client-contact-unit`, request);

export const fetchDashboardCollectionsAssignedToUsers = (assignToUsers: boolean) =>
  axios.get(`${url}/assigned-to-users`, { params: { assignToUsers } });

export const assignUnAssignToUsers = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-users`, request);

export const fetchDashboardCollectionsAssignedToJobs = (assignToJobs: boolean) =>
  axios.get(`${url}/assigned-to-jobs`, { params: { assignToJobs } });

export const assignUnAssignToJobs = (request: IComposableDashboardCollectionDTO) =>
  axios.post(`${url}/assign-unassign-to-jobs`, request);
